<div class="main">
  <app-icon class="icon" [path]="iconPath()" [size]="24" aria-hidden="true" [loading]="loading()" />
  <div class="content">
    <ng-container *appSkeleton="loading(); width: skeletonLabelWidth">
      @if (showMessage()) {
        <div
          class="message typography-small-regular"
          [innerHTML]="message() || (resolvedMessageKey() | translate: params())"
        ></div>
      }
    </ng-container>
  </div>
</div>
@if (resolvedActionKey(); as actionKey) {
  <button app-button class="action" (click)="action.emit()" variant="link">
    {{ actionKey | translate }}
  </button>
}
